import toIcon from '../toIcon';
import svg from './icon.svg';

const DateIcon = toIcon(svg);

export default DateIcon;
